(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattea-pqrs"]) return;
  try {
    
(function () {
  const form = document.getElementById('MatteaPqrForm');
  const successCode = document.getElementById('MatteaPqrSuccessCode');
  const storageKey = 'matteaLastPqr';

  if (successCode) {
    const savedCode = sessionStorage.getItem(storageKey);
    if (savedCode) successCode.textContent = savedCode;
  }

  if (!form) return;

  const codeField = document.getElementById('MatteaPqrCode');
  const dateField = document.getElementById('MatteaPqrDate');

  function makeCode() {
    const now = new Date();
    const date = now.toISOString().slice(0, 10).replaceAll('-', '');
    const time = now.toTimeString().slice(0, 8).replaceAll(':', '');
    const random = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'MATTEA-' + date + '-' + time + '-' + random;
  }

  function prepareTracking() {
    const code = makeCode();
    codeField.value = code;
    dateField.value = new Date().toLocaleString('es-CO', { timeZone: 'America/Bogota' });
    sessionStorage.setItem(storageKey, code);
  }

  prepareTracking();
  form.addEventListener('submit', prepareTracking);
})();

  } catch(e) { console.error(e); }
})();
})();
